<nav mat-tab-nav-bar [tabPanel]="tabPanel">
	<ng-content></ng-content>
</nav>
<mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>
